import styled from 'styled-components';
import ThemedTooltip from '../../../../theme/ThemedTooltip';

import { InfoDark } from '../../../../globalStyled';

export const StyledPlayerName = styled.span`
  font: inherit;
`;

export const StyledSaleLabel = styled.span`
  border-radius: 3px;
  padding: 1px 8px;
  text-transform: uppercase;
  font-size: 8px;
  font-weight: 500;
  color: ${({ isAcademy, $loan }) => (isAcademy || $loan ? '#fff' : '#000')};
  background-color: ${({ isAcademy, $loan }) => {
    if (isAcademy) return '#00996b';
    if ($loan) return '#6366f1';
    return '#fdca40';
  }};
  margin-left: 5px;
  line-height: 13px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const StyledInfoDark = styled(InfoDark)`
  margin-left: 3px;
  height: 10px;
  width: 10px;
`;
export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  max-width: 190px;
  white-space: normal;
  line-height: 20px;
  text-transform: none;
  text-align: center;
  &.__react_component_tooltip {
    pointer-events: auto !important;
    &.show {
      color: ${({ theme }) => theme.text} !important;
      border-radius: 6px;
      opacity: 1;
      text-align: left;
    }
  }
`;
